import React from "react";
import Kontaktmain from "../components/user/kontakt/Kontaktmain";

const Kontatk = () => {
  return (
    <div>
      <Kontaktmain />
    </div>
  );
};

export default Kontatk;
